import { withI18n } from 'react-i18next';
import RSearchBar from './RSearchBar';

export const pureComponent = RSearchBar;
export default withI18n()(RSearchBar);
